import { createRestClient } from '../api'
import { auth } from '../firebase'

export async function fetchFreshToken() {
  const firebaseToken = await auth.currentUser.getIdToken(true)

  // Call your verify API
  const rest = createRestClient()
  const response = await rest.post('/api/v1/verify', { token: firebaseToken })

  // Backend returns new API token?
  const apiToken = response?.data?.token

  // Save to storage
  localStorage.setItem('apiToken', apiToken)

  return apiToken
}

export function getStoredToken() {
  return localStorage.getItem('apiToken')
}
